import {
    AdLoadingStrategyTypeEnum,
    AdSizesTv,
    AdUnit,
    AdUnitSpecialUseCaseEnum,
    AdUnitTypeEnum,
    PageAdsBuilder
} from "@repo/lib-domain-tag";

import { pageBidderHelper } from "../pageBidderHelper";
import { deviceUtil, pageUtil } from "@repo/lib-common";

export class DesktopIndexPageAdsBuilder extends PageAdsBuilder {

    override init() {
        //this.setTargetingMap({"tehlikeli": "hayır", "sistem": "anasistem", "sozcuCat": "anasayfa"});
        this.setIsAutoRefreshEnabled(true);
        //sozcu_anasayfa_pageskin_tepe
        this.setIsAutoRefreshEnabled(true);
        this.applyAdUnit(
            AdUnit.builder(AdUnitTypeEnum.outOfPage_Interstitial)
                .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
                .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
                .setSpecialUseCaseIndex(0)
                .setIsEnabled(true)
                .setAdUnitPath("/66738120/szctv_interstitial")
                .setDivId("div-szctv_interstitial")
                .setDivStyleAfterRequest('')
                .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
                .setSizes(AdSizesTv.general_1x1)
                .setIsAutoRefreshEnabled(false)
                .setIsPrebidEnabled(false)
                .build()
        );
        this.applyAdUnit(
            AdUnit.builder(AdUnitTypeEnum.banner)
                .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
                .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
                .setIsEnabled(true)
                .setAdUnitPath("/66738120/szctv_masthead")
                .setDivId("div-szctv_masthead")
                .setDivStyleAfterRequest('')
                .setLoadingStrategy(AdLoadingStrategyTypeEnum.sra)
                .setSizes(AdSizesTv.desktop_Masthead)
                .setIsAutoRefreshEnabled(true)
                .setIsPrebidEnabled(true)
                .setPrebidSizeLimits(AdSizesTv.prebid_970x250)
                .setBidderHelper(pageBidderHelper)
                .setBidderCustomParam('taboola', { tagId: 'szctv_masthead' })
            //.onSlotRenderEnded(fixPageSkinCssClass)

        );
        this.applyAdUnit(
            AdUnit.builder(AdUnitTypeEnum.banner)
                .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
                .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
                .setIsEnabled(true)
                .setAdUnitPath("/66738120/szctv_box")
                .setDivId("div-szctv_box")
                .setDivStyleAfterRequest('')
                .setLoadingStrategy(AdLoadingStrategyTypeEnum.intersectionObserverBasedLazyLoad)
                .setSizes(AdSizesTv.prebid_300x250)
                .setIsAutoRefreshEnabled(true)
                .setIsPrebidEnabled(true)
                .setPrebidSizeLimits(AdSizesTv.prebid_300x250)
                .setBidderHelper(pageBidderHelper)
                .setBidderCustomParam('taboola', { tagId: 'szctv_box' })
            //.onSlotRenderEnded(fixPageSkinCssClass)

        );


        this.applyAdUnit(
            AdUnit.builder(AdUnitTypeEnum.banner)
                .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
                .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
                .setIsEnabled(true)
                .setAdUnitPath("/66738120/szctv_yatay_1")
                .setDivId("div-szctv_yatay_1")
                .setDivStyleAfterRequest('')
                .setLoadingStrategy(AdLoadingStrategyTypeEnum.intersectionObserverBasedLazyLoad)
                .setSizes(AdSizesTv.desktop_Masthead)
                .setIsAutoRefreshEnabled(true)
                .setIsPrebidEnabled(true)
                .setPrebidSizeLimits(AdSizesTv.prebid_970x250)
                .setBidderHelper(pageBidderHelper)
                .setBidderCustomParam('taboola', { tagId: 'szctv_yatay_1' })
            //.onSlotRenderEnded(fixPageSkinCssClass)

        );
        // this.applyAdUnit(
        //     AdUnit.builder(AdUnitTypeEnum.banner)
        //         .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        //         .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
        //         .setIsEnabled(true)
        //         .setAdUnitPath("/66738120/szctv_kule_sol")
        //         .setDivId("div-szctv_kule_sol")
        //         .setDivStyleAfterRequest('')
        //         .setLoadingStrategy(AdLoadingStrategyTypeEnum.sra)
        //         .setSizes(AdSizesTv.desktop_Tower)
        //         .setIsAutoRefreshEnabled(true)
        //         .setIsPrebidEnabled(true)
        //         .setPrebidSizeLimits(AdSizesTv.prebid_300x600)
        //         .setBidderHelper(pageBidderHelper)
        //         .setBidderCustomParam('taboola', { tagId: 'szctv_kule_sol' })
        //     //.onSlotRenderEnded(fixPageSkinCssClass)
        //
        // );
        //
        // this.applyAdUnit(
        //     AdUnit.builder(AdUnitTypeEnum.banner)
        //         .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        //         .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
        //         .setIsEnabled(true)
        //         .setAdUnitPath("/66738120/szctv_kule_sag")
        //         .setDivId("div-szctv_kule_sag")
        //         .setDivStyleAfterRequest('')
        //         .setLoadingStrategy(AdLoadingStrategyTypeEnum.sra)
        //         .setSizes(AdSizesTv.desktop_Tower)
        //         .setIsAutoRefreshEnabled(true)
        //         .setIsPrebidEnabled(true)
        //         .setPrebidSizeLimits(AdSizesTv.prebid_300x600)
        //         .setBidderHelper(pageBidderHelper)
        //         .setBidderCustomParam('taboola', { tagId: 'szctv_kule_sag' })
        //     //.onSlotRenderEnded(fixPageSkinCssClass)
        //
        // );

        

        // this.applyAdUnit(
        //     AdUnit.builder(AdUnitTypeEnum.banner)
        //         .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        //         .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
        //         .setIsEnabled(true)
        //         .setAdUnitPath("/66738120/szctv_yatay_footer")
        //         .setDivId("div-szctv_yatay_footer")
        //         .setDivStyleAfterRequest('')
        //         .setLoadingStrategy(AdLoadingStrategyTypeEnum.intersectionObserverBasedLazyLoad)
        //         .setSizes(AdSizesTv.desktop_Masthead)
        //         .setIsAutoRefreshEnabled(true)
        //         .setIsPrebidEnabled(true)
        //         .setPrebidSizeLimits(AdSizesTv.prebid_970x250)
        //         .setBidderHelper(pageBidderHelper)
        //         .setBidderCustomParam('taboola', { tagId: 'szctv_yatay_footer' })
        //     //.onSlotRenderEnded(fixPageSkinCssClass)
        //
        // );

    }
}
export const desktopIndexPageAdsBuilder = new DesktopIndexPageAdsBuilder(deviceUtil.DeviceTypeEnum.desktop, pageUtil.PageTypeEnum.index);


